import useEventListener from './useEventListener';
export default function useMultiSelection({ stage, isSelectionActiveRef, }) {
    useEventListener('keydown', (event) => {
        event.stopPropagation();
        if (event.ctrlKey || event.altKey) {
            stage === null || stage === void 0 ? void 0 : stage.draggable(false);
            isSelectionActiveRef.current = true;
        }
    });
    useEventListener('keyup', (event) => {
        event.stopPropagation();
        if (event.ctrlKey || event.altKey) {
            stage === null || stage === void 0 ? void 0 : stage.draggable(false);
            isSelectionActiveRef.current = true;
        }
    });
}
